import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../firebase/config';
import './ForgotPassword.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      // Firebase がメール送信を自動実行
      await sendPasswordResetEmail(auth, email, {
        url: `${window.location.origin}/login`, // リセット完了後のリダイレクト先
        handleCodeInApp: false
      });
      
      setSent(true);
    } catch (error) {
      console.error('パスワードリセットエラー:', error);
      
      switch (error.code) {
        case 'auth/user-not-found':
          setError('このメールアドレスは登録されていません。');
          break;
        case 'auth/invalid-email':
          setError('有効なメールアドレスを入力してください。');
          break;
        case 'auth/too-many-requests':
          setError('しばらく時間をおいてから再試行してください。');
          break;
        default:
          setError('パスワードリセットメールの送信に失敗しました。');
      }
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div className="forgot-password-container">
        <div className="forgot-password-box">
          <img src="/img/tiny-identity.png" alt="Tiny Identity" className="forgot-logo" />
          <h1 className="forgot-title">Tiny identity</h1>
          
          <div className="forgot-success-message">
            <p>パスワードリセット用のメールを送信しました。<br/>
                メール内のリンクをクリックし、新しいパスワードを設定してください。</p>
            <p className="forgot-note">※メールが届かない場合は、迷惑メールフォルダもご確認ください。</p>
          </div>
          
          <button 
            className="forgot-btn-primary" 
            onClick={() => navigate('/login')}
          >
            ログイン画面に戻る
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="forgot-password-container">
      <div className="forgot-password-box">
        <img src="/img/tiny-identity.png" alt="Tiny Identity" className="forgot-logo" />
        <h1 className="forgot-title">Tiny identity</h1>
        
        <p className="forgot-description">
          登録時のメールアドレスを入力してください。<br />
          パスワードリセット用のメールをお送りします。
        </p>

        {error && (
          <div className="forgot-error-message">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="forgot-form-group">
            <label htmlFor="email">メールアドレス</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
              placeholder="example@email.com"
            />
          </div>

          <button 
            type="submit" 
            className="forgot-btn-primary"
            disabled={loading || !email}
          >
            {loading ? '送信中...' : 'リセットメールを送信'}
          </button>
        </form>

        <button 
          className="forgot-btn-outline" 
          onClick={() => navigate('/login')}
          disabled={loading}
        >
          ログイン画面に戻る
        </button>

        <button 
          className="forgot-btn-text" 
          onClick={() => navigate('/')}
          disabled={loading}
        >
          スタート画面に戻る
        </button>
      </div>
    </div>
  );
};

export default ForgotPassword;
